<template>
  <div id="reportContainer" class="report-container">
    <component
      :is="currentComponent"
      :cases="cases"
      :title="title"
      :district="district"
      :header="reportHeader"
      :formName="reportFormName"
      @reportLoaded="reportLoaded"
    />
  </div>
</template>

<script>
import R01_DefaultTemplate from "@/components/report-templates/R01/Default";
import R03_DefaultTemplate from "@/components/report-templates/R03/Default";
import RI_DefaultTemplate from "@/components/report-templates/RI/Default";

export default {
  name: "report-container",
  props: ["reportType", "cases", "title", "district"],
  components: {
    R01_DefaultTemplate,
    R03_DefaultTemplate,
    RI_DefaultTemplate,
  },
  data() {
    return {
      currentComponent: "RI_DefaultTemplate",
      reportHeader: "SYARIKAT KONSESI",
      reportFormName: "Borang JKR.PK(SJ).P.01-25",
    };
  },
  watch: {
    reportType: {
      handler() {
        if (this.reportType) {
          let reportTemplate = `${this.reportType}_DefaultTemplate`;

          const isComponentExists = this.$options.components[reportTemplate];

          this.currentComponent = isComponentExists
            ? reportTemplate
            : "RI_DefaultTemplate";
        } else {
          this.currentComponent = "RI_DefaultTemplate";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    reportLoaded(e) {
      this.$emit("reportLoaded", e);
    },
  },
};
</script>